
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/latest",
      function () {
        return require("private-next-pages/article/latest/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/latest"])
      });
    }
  